import { combineReducers } from "redux";
import rendering from "./reducers/rendering";
import content from "./reducers/content";

export default combineReducers({ rendering, content });
